import React, { PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Row, Col, Container } from "react-bootstrap";

import CajaTexto from "../../../components/UI/cajaTexto/cajaTexto.jsx";
import CajaTextoNumero from "../../../components/UI/cajaTexto/cajaTextoNumero.jsx";
import Select from "../../../components/UI/Select/Select";
import { checkEmail } from '../../../components/Util/Util';
import { SiteRutas } from "../../../request/RutasConfig";
import { Notificacion } from "../../../components/Util/Notificacion/Notificacion";

import { Call_Center_Detalle, Call_Center_Agregar, Call_Center_Modificar, Obtener_Cadenas_Empresa } from "../../../request/MantenimientosRequest";

class TabDetalle extends PureComponent {
  _isMounted = false;

  state = {
    Datos: {
      EmpId: {
        value: 0,
        attributes: {
          readOnly: true,
          focus: false,
          hidden: "none",
          label: ""
        }
      },
      Id: {
        value: 0,
        attributes: {
          readOnly: true,
          focus: false,
          hidden: "unset",
          label: "ID:"
        }
      },
      Nombre: {
        value: "",
        attributes: {
          readOnly: false,
          focus: false,
          hidden: "unset",
          label: "Nombre:",
          maxLength: 30,
          minLength: 1,
          pattern: ""
        }
      },
      CadenaId: {
        value: 0,
        attributes: {
          readOnly: false,
          focus: false,
          hidden: "unset",
          label: "Cadena:"
        }
      },
      Mail: {
        value: "",
        attributes: {
          readOnly: false,
          focus: false,
          hidden: "unset",
          label: "Correo:",
          maxLength: 50
        }
      },
      Telefonos: {
        value: "",
        attributes: {
          readOnly: false,
          focus: false,
          hidden: "unset",
          label: "Teléfono:",
          maxLength: 100
        }
      }
    },
    lstCadenas: [],
    Id: 0,
    RegCallCenter: {
      EmpId: 0,
      Id: 0,
      CadenaId: 0,
      Nombre: "",
      Mail: "",
      Telefonos: ""
    },
    token: "",
    empresa: 0,
    menuId: 0
  }

  componentDidMount = async () => {
    this._isMounted = true;

    let menuId = 0;
    if (this.props.location.state) {
      menuId = this.props.location.state.menuId;
    }

    let Datos = { ...this.state.Datos };
    const Id = this.props.Id;
    const empresa = this.props.empresa.Id;
    const token = this.props.token;

    let lstCadenas = [{ CadenaId: 0, Nombre: "Seleccione" }];

    let response = await Obtener_Cadenas_Empresa(token, empresa);
    if (response.Exitoso) {
      response.Datos.forEach((item) => {
        lstCadenas.push({ CadenaId: item.CadenaId, Nombre: item.Nombre });
      });
    } else {
      Notificacion.error(response.Mensaje);
    }

    const DatosCallCenter = Id > 0 ? await this.cargarCallCenter(token, empresa, Id) : Datos;
    this._isMounted && this.setState({ Datos: DatosCallCenter, Id, token, empresa, lstCadenas, menuId });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  cargarCallCenter = async (pToken, pEmpresa, pid) => {
    let Datos = { ...this.state.Datos };
    let RegCallCenter = null;

    if (pid > 0) {
      RegCallCenter = await Call_Center_Detalle(pToken, pid, pEmpresa);

      if (RegCallCenter != null) {
        Datos.EmpId.value = RegCallCenter.EmpId;
        Datos.Id.value = RegCallCenter.Id;
        Datos.Nombre.value = RegCallCenter.Nombre;
        Datos.Mail.value = RegCallCenter.Mail;
        Datos.Telefonos.value = RegCallCenter.Telefonos;
        Datos.CadenaId.value = RegCallCenter.CadenaId;
        Datos.CadenaId.attributes.readOnly = true;
        this.props.guardarCadenaId(Datos.CadenaId.value);

        this.setState({ RegCallCenter });
      }
    }

    return Datos;
  }

  llenarListaDatos = () => {
    const Datos = this.state.Datos;

    let RegCallCenter = { ...this.state.RegCallCenter };
    RegCallCenter.EmpId = Datos.EmpId.value;
    RegCallCenter.Id = Datos.Id.value;
    RegCallCenter.CadenaId = Datos.CadenaId.value;
    RegCallCenter.Nombre = Datos.Nombre.value;
    RegCallCenter.Mail = Datos.Mail.value;
    RegCallCenter.Telefonos = Datos.Telefonos.value;

    return RegCallCenter;
  }

  validarDatos = () => {
    const _datos = this.state.Datos;

    if (!_datos.Nombre.value.trim()) {
      Notificacion.error("Error: Debe ingresar el dato: Nombre");
      return false;
    }

    if (!_datos.CadenaId.value) {
      Notificacion.error("Error: Debe seleccionar el dato: Cadena");
      return false;
    }

    if (!_datos.CadenaId.value) {
      Notificacion.error("Error: Debe seleccionar el dato: Cadena");
      return false;
    }

    if (!_datos.Mail.value.trim()) {
      Notificacion.error("Error: Debe ingresar el dato: Correo");
      return false;
    }

    if (!_datos.Telefonos.value.trim()) {
      Notificacion.error("Error: Debe ingresar el dato: Teléfono");
      return false;
    }

    if (!checkEmail(_datos.Mail.value.trim())) {
      Notificacion.error("Error: Formato Incorrecto: Correo");
      return false;
    }

    if (!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(_datos.Telefonos.value.trim())) {
      Notificacion.error("Error: Formato Incorrecto: Telefono");
      return false;
    }

    return true;
  }

  ingresarDatos = async () => {

    if (this.validarDatos()) {
      const _id = this.props.Id;
      const token = this.props.token;
      const empresa = this.props.empresa.Id;

      const pCallCenter = this.llenarListaDatos();
      let resultado = null;
      if (_id > 0) {
        resultado = await Call_Center_Modificar(token, pCallCenter.Id, empresa, pCallCenter.Nombre, pCallCenter.Telefonos, pCallCenter.Mail, pCallCenter.CadenaId);
      } else {
        resultado = await Call_Center_Agregar(token, pCallCenter.Id, empresa, pCallCenter.Nombre, pCallCenter.Telefonos, pCallCenter.Mail, pCallCenter.CadenaId);
      }

      if (resultado.Exitoso) {
        if (_id > 0) {
          Notificacion.success("Se actualizó la información con éxito ");
          this.props.guardarCadenaId(pCallCenter.CadenaId);
        } else {
          Notificacion.success("Se almacenó la información con éxito");

          let Id = resultado.Mensaje.split(":")[1];
          let Datos = { ...this.state.Datos };
          Datos.Id.value = Id;
          Datos.CadenaId.attributes.readOnly = true;

          this.setState({ Datos });
          this.props.guardarId(Id);
          this.props.guardarCadenaId(pCallCenter.CadenaId);
        }
      } else {
        Notificacion.error("Error: " + resultado.Mensaje);
      }
    }
  }

  volverAtras = () => {
    let menuId = this.state.menuId;
    this.props.history.push({ pathname: `${SiteRutas.CallCenter}`, state: { menuId: menuId } });
  };

  onSelectChanged = (event) => {
    const { value } = event.target;

    let Datos = { ...this.state.Datos };
    Datos.CadenaId.value = value;

    this.setState({ Datos });
  };

  onChangeInput = (e) => {
    const { name, value } = e.target;

    const newAttributes = this.state.Datos[name].attributes;
    const pattern = newAttributes.pattern ? newAttributes.pattern : "";

    if (pattern) {
      if (value.match(pattern) != null) {
        const Datos = Object.assign({}, this.state.Datos, { [name]: { value: value, attributes: newAttributes } });
        this.setState({ Datos });
      }
    } else {
      const Datos = Object.assign({}, this.state.Datos, { [name]: { value: value, attributes: newAttributes } });
      this.setState({ Datos });
    }
  }

  onBlurInput = () => { };

  render() {
    const { lstCadenas, Datos } = this.state;

    const disabledCadena = Datos.CadenaId.attributes.readOnly ? { disabled: true } : {};

    return (
      <Container>
        <Row>
          <Col>
            <CajaTextoNumero
              id="Id"
              type="number"
              label={Datos.Id.attributes.label}
              value={Datos.Id.value}
              attributes={Datos.Id.attributes}
            />
          </Col>
          <Col>
            <CajaTexto
              id="Nombre"
              type="text"
              label={Datos.Nombre.attributes.label}
              value={Datos.Nombre.value}
              attributes={Datos.Nombre.attributes}
              onChangeInput={this.onChangeInput}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Select
              id="dllCadena"
              name="Cadena"
              {...disabledCadena}
              labelText={Datos.CadenaId.attributes.label}
              classNameContainer="form-group"
              className="form-control"
              value={Datos.CadenaId.value}
              onChange={this.onSelectChanged}
              configuration={{
                valueField: "CadenaId",
                textField: "Nombre",
                options: lstCadenas,
              }}
            />
          </Col>
          <Col>
            <CajaTexto
              id="Mail"
              type="text"
              label={Datos.Mail.attributes.label}
              value={Datos.Mail.value}
              attributes={Datos.Mail.attributes}
              onChangeInput={this.onChangeInput}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <CajaTexto
              id="Telefonos"
              type="text"
              label={Datos.Telefonos.attributes.label}
              value={Datos.Telefonos.value}
              attributes={Datos.Telefonos.attributes}
              onChangeInput={this.onChangeInput}
            />
          </Col>
        </Row>
        <hr />
        <Row className="mb-3">
          <Col className="text-right">
            <div className="tooltip2">
              <span className="tooltiptext2">Cancelar</span>
              <Button variant="secondary" onClick={this.volverAtras}>
                Cancelar
              </Button>
            </div>
            &nbsp;
            <div className="tooltip2">
              <span className="tooltiptext2">Guardar</span>
              <Button variant="primary" onClick={this.ingresarDatos}>
                Guardar
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.usuario.token,
    empresa: state.parametros.empresa,
  };
};

export default connect(mapStateToProps)(withRouter(memo(TabDetalle)));
